
import { defineComponent } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default defineComponent({
  name: "TextInput",
  components: {
    FontAwesomeIcon,
  },
  props: {
    modelValue: String,
    id: String,
    label: String,
    placeholder: String,
    focused: Boolean,
    validationError: {
      type: [String, Boolean],
      validator(value: "valid" | "invalid" | false) {
        return ["valid", "invalid", false].includes(value);
      },
    },
  },
  emits: ["update:modelValue"],
  mounted() {
    if (this.focused) {
      const inputField = this.$refs.reference as HTMLInputElement;
      inputField.focus();
    }
  },
  computed: {
    getValidationClass() {
      if (this.validationError === false) {
        return "";
      }
      return this.validationError === "invalid"
        ? "form__input--invalid"
        : "form__input--valid";
    },
  },
});
